Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.FacebookContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.FacebookContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.group_type == 'datasift' and socialContent.data and socialContent.data.type == 'facebook'